import { css, jsx } from '@emotion/core';
import React from 'react';

import Container from '@/src/shared/components/Container';
import Heading from '@/src/shared/components/Heading';
import { save } from '@/src/shared/components/SavedSearchModal/utils';
import { bp } from '@/styles';

import ComplianceChart from './ComplianceChart';

const styles = {
  savedContainer: css`
    padding-left: 0;
    padding-right: 0;
    @media ${bp.sm} {
      padding-left: 16px;
      padding-right: 16px;
    }
  `,
  cardContainer: css`
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    @media ${bp.sm} {
      margin: -10px;
    }
  `,
  header: css`
    font-size: 2.8rem;
    padding-left: 16px;
    margin-bottom: 40px;
    @media ${bp.md} {
      padding-left: 0px;
      font-size: 3.6rem;
    }
  `,
};

const SavedCompliance = ({ savedSearches }) => {
  return (
    <Container css={styles.savedContainer}>
      <Heading css={styles.header} theme="primaryGray" type="2" weight="bolder">
        Saved Compliance Charts
      </Heading>
      <div css={styles.cardContainer}>
        {savedSearches.map(ss => (
          <ComplianceChart key={ss.SearchId} data={ss} iconName="Claims" />
        ))}
      </div>
    </Container>
  );
};

export default SavedCompliance;
